export default "/fr/_next/static/assets/fonts/InterVariable.499fcada6ddb2c38718c2c16a190d639.woff2";